import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useAddressMutations } from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Modal, Button } from '@repo/ui'
import type { Address } from 'types'

interface SetDefaultAddressModalProps {
  address?: Address | null
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const SetDefaultAddressModal = (props: SetDefaultAddressModalProps) => {
  const { address, open, onClose = () => {}, refetch } = props

  const { open: notification } = useSnackbar()
  const { setDefault, isSettingDefault } = useAddressMutations()

  const handleClose = () => {
    onClose()
  }

  const handleSetDefaultAddress = async () => {
    if (!address) return
    try {
      await setDefault({ id: address.id })
      refetch()
      handleClose()
    } catch (error) {
      notification({ type: 'error', title: getErrorMessage(error) || 'Could not set default address' })
    }
  }

  const addressName = address?.label || address?.full_name || 'this address'

  return (
    <Modal
      title="Set default address"
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button disableElevation variant="secondary" onClick={handleClose} disabled={isSettingDefault}>
            Cancel
          </Button>
          <Button variant="primary" disableElevation loading={isSettingDefault} onClick={handleSetDefaultAddress}>
            Continue
          </Button>
        </>
      }
    >
      <Stack spacing={4}>
        <Typography variant="body2" color="text.secondary">
          {`Would you like to set "${addressName}" as the default address?`}
        </Typography>
      </Stack>
    </Modal>
  )
}
